export default __webpack_public_path__ + "static/media/31.099d2331.png";